import React from 'react';
import { MODAL_ACTIONS_OPEN, MODAL_ACTIONS_CHANGE_PROPS, MODAL_ACTIONS_CLOSE, ModalsActionTypes } from './ModalsActionTypes';

export interface IModalProps {
  title?: string | React.ElementType | React.ReactNode,
  content?: any,
  genericProps?: any
}

export type ModalPropsTypes = IModalProps 

export interface IModalReducer {
  component?: React.ElementType,
  componentProps?: IModalProps,
  key: string,
  opened?: boolean
}

export interface IModalOpenReducer extends IModalReducer {
  component: React.ElementType,
  key: string,
  opened: boolean
}

export interface IModalChangePropsReducer extends IModalReducer {
  componentProps: IModalProps,
  key: string
}

export interface IModalCloseReducer extends IModalReducer {
  key: string
}

export interface IModalsReducer {
  modals: IModalReducer[]
}

const INITIAL_STATE: IModalsReducer = {
  modals: []
};

const getStateToOpen = (state: IModalsReducer, modal: IModalReducer) => {
  let newState: IModalsReducer = { ...state };
  const modalIndex: number = state.modals.map((modalItem: IModalReducer) => {
    return modalItem.key;
  }).indexOf(modal.key);
  if (modalIndex > -1) {
    newState.modals[modalIndex] = modal;
  } else {
    newState.modals.push(modal);
  }
  return newState;
}

const getStateChangeProps = (state: IModalsReducer, key: string, componentProps?: IModalProps) => {
  let newState: IModalsReducer = { ...state };
  const modalIndex: number = state.modals.map((modalItem: IModalReducer) => {
    return modalItem.key;
  }).indexOf(key);
  if ( modalIndex > -1 ) {
    newState.modals[modalIndex] = {
      ...newState.modals[modalIndex],
      componentProps: {
        ...newState.modals[modalIndex].componentProps,
        ...componentProps
      }
    };
  }
  return newState;
}

const getStateToClose = (state: IModalsReducer, key: string) => {
  let newState: IModalsReducer = { ...state };
  const modalIndex: number = state.modals.map((modalItem: IModalReducer) => {
    return modalItem.key;
  }).indexOf(key);
  if (modalIndex > -1) {
    newState.modals[modalIndex] = {
      ...newState.modals[modalIndex],
      opened: false
    };
  }
  return newState;
}

export default (state: IModalsReducer = INITIAL_STATE, action: ModalsActionTypes) => {
  switch (action.type) {
    case MODAL_ACTIONS_OPEN:
      return getStateToOpen(state, action.payload);
    case MODAL_ACTIONS_CHANGE_PROPS:
      return getStateChangeProps(state, action.payload.key, action.payload.componentProps);
    case MODAL_ACTIONS_CLOSE:
      return getStateToClose(state, action.payload.key);
    default:
      return state;
  }
};